import { useMemo } from "react";

import { MedChronExportService } from "../services/medChronExportService";
import { useAPI } from "./useAPI";

export const useMedChronExportService = () => {
  const api = useAPI();
  return useMemo(() => new MedChronExportService(api), [api]);
};
